//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const TABLE_LIST_COLUMNS = [
  {
    name: "retailer",
    label: "Nivel",
    align: "left",
    field: (row) => row.retailer_name,
    sortable: false,
  },
  {
    name: "user_name",
    label: "Nome de Utilizador",
    align: "left",
    field: (row) => row.user_name,
    sortable: false,
  },
];

export default {
  name: "PortalCredentialManagerTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: () => {},
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10, // current rows per page being displayed
    },
    columns: TABLE_LIST_COLUMNS,
  }),
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
    statusColumn(state) {
      return state;
    },
  },
};
